module.exports = __webpack_public_path__ + "8658ec2a04e85c08683c263f77716fb4.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/theater-2014.jpg
// module id = 676
// module chunks = 0